import * as React from 'react';

const TriangleDownChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="triangle-down-chunky_svg__eds-icon--triangle-down-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="triangle-down-chunky_svg__eds-icon--triangle-down-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.2 10L12 14.2 7.8 10z"
        />
    </svg>
);

TriangleDownChunkySvg.displayName = 'TriangleDownChunkySvg';
export default TriangleDownChunkySvg;
